{
  "changeChain": {
    "title": "选择链"
  },
  "checkoutBlocked": {
    "notAvailable": "不可用",
    "regionMessage": "该服务在您所在的地区不可用。",
    "viewRegions": "查看可用地区。"
  },
  "common": {
    "addressCopied": "地址已复制",
    "back": "返回",
    "cancel": "取消",
    "close": "关闭",
    "confirm": "确认",
    "continue": "继续",
    "copied": "已复制！",
    "copy": "复制",
    "copyAddress": "复制地址",
    "done": "完成",
    "go": "前往",
    "loading": "加载中…",
    "ok": "好",
    "poweredBy": "技术支持",
    "tryAgain": "重试",
    "startOver": "重新开始"
  },
  "depositAmount": {
    "amountLabel": "金额",
    "changeToMaximum": "改为最高金额",
    "changeToMinimum": "改为最低金额",
    "delete": "删除",
    "enterAmount": "请输入金额",
    "fee": "手续费 {{amount}}",
    "maximumAmount": "最高存款金额 {{amount}}",
    "minimumAmount": "最低存款金额 {{amount}}",
    "title": "充值",
    "submit": "存入",
    "submitWithMethod": "使用{{method}}存入"
  },
  "feeDetails": {
    "amount": "金额",
    "fee": "手续费 {{rate}}",
    "summaryAddedToCharge": "使用 {{method}} 充值将收取 {{rate}} 手续费，该费用将计入您的总扣款金额。",
    "summaryDeductedFromDeposit": "使用 {{method}} 充值将收取 {{rate}} 手续费，该费用将从您收到的金额中扣除。",
    "title": "手续费详情",
    "totalCost": "总计",
    "youllGet": "实际到账"
  },
  "fiat": {
    "agreeAndContinue": "同意条款并继续",
    "amountLabel": "存入金额",
    "applePay": "Apple Pay",
    "applePayNotSetUp": "请在 Apple 钱包中添加银行卡后重试。",
    "applePayUnsupported": "此设备无法使用 Apple Pay 支付。",
    "blocked": "存入功能在您所在的地区不可用",
    "card": "银行卡",
    "contactVerifyBoth": "请验证您的手机号码和邮箱地址",
    "contactVerifyEmail": "请验证您的邮箱地址",
    "contactVerifyPhone": "请验证您的手机号码",
    "countryHeading": "您的国家/地区",
    "countrySearchPlaceholder": "搜索",
    "delete": "删除",
    "deposit": "存入",
    "depositReceived": "已收到 {{amount}} 存入",
    "depositReceivedFrom": "来自 {{method}}",
    "emailPlaceholder": "您的邮箱",
    "failure": "存入失败",
    "fee": "{{amount}} 手续费",
    "getNewPrice": "获取新报价",
    "kycConsentCheck": "我同意 Fun 核实我的身份，并将结果共享给完成我订单的支付服务商。详情请参阅：",
    "kycConsentPrompt": "继续即表示您同意 Fun 核实您的身份，并将结果共享给完成您订单的支付服务商。详情请参阅：",
    "kycConsentStop": "。",
    "kycDetailAddress": "请填写您的地址",
    "kycDetailDob": "请输入您的出生日期",
    "kycDetailName": "为保障您的存款安全，我们需要进一步核实您的身份信息。",
    "kycDetailNationality": "您的国籍",
    "kycDetailOther": "请填写其余信息",
    "kycDetailSsn": "请填写您的 9 位 SSN",
    "kycFileUnsupported": "此处暂不支持上传文件——您很快就能完成此步骤。",
    "kycFormDetail": "首次存入前需要填写一些信息。",
    "kycFormInvalid": "其中部分信息需要再确认一下。",
    "kycPhoneInUse": "此电话号码已用于另一个 {{provider}} 账户。请使用其他号码。",
    "kycTaxIdInUse": "此税号已用于另一个 {{provider}} 账户。",
    "kycFormMissing": "缺少部分必填信息。",
    "kycFormStale": "此步骤已更新，请检查以下信息。",
    "kycFormTitle": "验证您的身份",
    "kycIntroDetail": "这有助于我们处理你的存款，同时保障你的账户安全。只需一分钟，无需提供身份证件。",
    "kycNoticeCountryCode": "请输入两位国家代码，例如 AU",
    "kycNoticeDateFormat": "请使用 YYYY-MM-DD 格式",
    "kycNoticeDatePast": "请输入过去的日期",
    "kycNoticeInvalid": "请检查高亮显示的字段",
    "kycNoticeRequired": "请填写高亮显示的字段",
    "kycNoticeUnderage": "您必须年满 18 岁才能继续",
    "kycOnHold": "验证已暂停",
    "kycOnHoldDetail": "您可以稍后再回来重试。",
    "kycOnHoldUntil": "你可以在 {{date}} 之后重试。",
    "kycOpenLink": "继续验证",
    "kycOptional": "选填",
    "kycPrivacyPolicy": "隐私政策",
    "kycProviderGeneric": "支付服务商",
    "kycProviderGenericId": "我们的验证合作伙伴",
    "kycProviderTerms": "{{provider}}的条款与条件",
    "kycProviderTermsPrompt": "继续即表示您同意：",
    "kycRejected": "验证未通过",
    "kycRejectedSupport": "请联系客服，我们会为你查看。",
    "kycRequired": "验证并存入",
    "kycRequiredCta": "需要验证 →",
    "kycRequiredDetail": "请完成验证后继续存入。",
    "kycRequiredTitle": "需要身份验证",
    "kycCompleteDetail": "您的存入限额已提高。",
    "kycCompleteTitle": "身份验证已完成",
    "kycHardCta": "查看选项 →",
    "kycHardDetail": "我们无法通过身份验证提高您的存入限额。",
    "kycHardTitle": "无法验证您的身份",
    "kycPendingCta": "等待验证 →",
    "kycPendingDetail": "我们正在尽快完成您的身份验证。",
    "kycPendingTitle": "身份验证进行中",
    "kycSoftCta": "需要验证 →",
    "kycSoftDetail": "您可以重试并更正验证中的问题。",
    "kycSoftTitle": "身份验证未通过",
    "kycOptionCloseDetail": "先退出，稍后再回到这笔存款。",
    "kycOptionCloseTitle": "关闭存款",
    "kycOptionMaxDetail": "验证前最多 {{max}}。",
    "kycOptionMaxDetailUnknown": "验证前最多为当前限额。",
    "kycOptionMaxTitle": "存入上限金额",
    "kycOptionRedoDetail": "请确认您的信息和证件后再试一次。",
    "kycOptionRedoTitle": "重新进行身份验证",
    "kycOptionSupportDetail": "如有身份验证要求相关问题，请联系我们。",
    "kycOptionSupportTitle": "获取帮助与支持",
    "kycOptionsHardTitle": "身份验证后我们仍无法提高您的存入限额。",
    "kycOptionsLabel": "您现在可以：",
    "kycOptionsPendingTitle": "您的身份验证仍在处理中。您的存入限额尚未变更。",
    "kycOptionsSoftTitle": "您的身份验证未通过。请更正上次尝试中的问题后重试。",
    "kycTitle": "身份验证",
    "otpDetailAnyEmail": "验证码已发送至您的邮箱",
    "otpDetailAnyPhone": "验证码已发送至您的手机",
    "otpDetailEmail": "验证码已发送至 {{email}}",
    "otpDetailPhone": "验证码已发送至 {{phone}}",
    "otpError": "该验证码无效。请检查后重试。",
    "otpExpired": "该验证码已过期。请获取新的验证码。",
    "otpRateLimited": "请求验证码次数过多。请稍后再试。",
    "otpRateLimitedTitle": "请稍后再请求新的验证码",
    "otpPlaceholder": "6 位验证码",
    "otpResend": "重新发送",
    "otpResendPrompt": "没有收到验证码？",
    "otpTitle": "输入验证码",
    "payButton": "使用 Apple Pay 存入",
    "paySheetPay": "支付",
    "paySheetTitle": "使用 Apple Pay 确认",
    "paySheetTotal": "总计 {{amount}}",
    "phoneCountryLabel": "国家/地区代码",
    "phoneCountrySearch": "搜索国家/地区",
    "phonePlaceholder": "您的手机号码",
    "processing": "正在处理您的存入…",
    "pendingOrderTitle": "您有一笔未完成的充值",
    "pendingOrderDetail": "继续您的 {{amount}} 充值，或取消后使用新金额继续。",
    "resumeDeposit": "继续充值",
    "cancelDeposit": "取消充值",
    "quoteExpired": "该报价已过期",
    "quoteFailed": "无法获取价格",
    "redirectDetail": "你返回后我们会立即更新此页面。",
    "redirectReopen": "重新打开浏览器",
    "redirectTitle": "请在浏览器中完成支付",
    "refunded": "存入已退款",
    "refusalDetails": "请检查您输入的内容后重试。",
    "refusalDetailsTitle": "部分信息需要再核对一下",
    "refusalLimits": "请尝试较小的金额或其他付款方式。",
    "refusalLimitsTitle": "此付款方式无法处理该金额",
    "refusalUnavailable": "这是我们这边的问题——请稍后重试，或尝试较小的金额。",
    "refusalUnavailableTitle": "目前没有可用的付款选项",
    "requote": "获取新报价",
    "reviewTitle": "确认您的存入",
    "orderConfirmingTitle": "正在确认您的付款",
    "orderConfirmingDetail": "您的付款已成功。我们正在记录您的存款，这可能需要一点时间。",
    "submitFailed": "提交失败",
    "paymentFailed": "请重试",
    "submitting": "提交中",
    "stripeAuthDetail": "我们将使用 {{email}} 通过 Link 安全地继续。",
    "stripeAuthorizing": "在 Stripe 中继续",
    "stripeAuthorizingDetail": "请在 Stripe 窗口中完成 Link 验证和授权。",
    "stripeAuthTitle": "使用 Stripe 继续",
    "stripeAuthFailed": "无法启动您的 Stripe 会话。请重试。",
    "stripeKycInfoFailed": "无法将您的信息保存至 Stripe。请检查后重试。",
    "stripeRegistrationFailed": "无法创建您的 Link 账户。请检查信息后重试。",
    "success": "存入完成",
    "successDetail": "您的余额将很快更新。",
    "termsNotice": "继续即表示您同意服务提供商的\n<terms>条款</terms>。",
    "unsupported": "此步骤暂不可用",
    "verifying": "正在验证您的身份…",
    "verifyingDetail": "通常不到一分钟即可完成。",
    "verifyingSlow": "仍在验证",
    "verifyingSlowDetail": "你可以先关闭，稍后再来查看。",
    "coinbaseTermsNotice": "继续即表示您同意 Coinbase 的\n<terms>条款</terms>、<agreement>用户协议</agreement>和<privacy>隐私政策</privacy>。",
    "contactInvalidEmail": "请输入有效的电子邮件地址",
    "kycIntroTitle": "让我们验证您的身份",
    "kycAdditionalTitle": "我们还需要一点信息",
    "kycAdditionalDetail": "提高存款限额需要进行额外验证。验证完成后，即可使用更高的限额。",
    "kycFindOutMore": "了解更多",
    "kycR2Consent": "继续即表示您同意Fun验证您的身份，并与指定的支付服务提供商共享验证结果。",
    "kycAgreeContinue": "同意并继续",
    "kycSsnLastFour": "请输入您的SSN\n最后4位数字",
    "kycSsnProtection": "根据美国法律，我们需要收集SSN以验证身份。您的信息受到银行级加密保护。",
    "kycDetailCountry": "您的国家",
    "kycCountry": "国家",
    "kycDetailOccupation": "您的职业",
    "kycDetailPurpose": "请提供您的交易目的",
    "kycOccupation": "职业",
    "kycPurpose": "交易目的",
    "kycDetailPhone": "您的手机号码",
    "kycDetailEmployment": "您的就业状况",
    "kycDetailSourceOfWealth": "您的财富来源",
    "kycDetailIncome": "您的年总收入",
    "kycDetailActivity": "您的每月活动",
    "kycIncomeCaption": "税前，以您的当地货币计",
    "kycReviewTitle": "谢谢！我们已收到您的信息，正在审核中。",
    "kycHoldTitle": "谢谢！我们已收到您的信息。我们还需要一些时间来完成审核。",
    "kycRestrictedTitle": "您的账户已受到限制。",
    "regionUnsupportedTitle": "您所在的地区不受支持。",
    "kycAnyQuestions": "有任何问题？",
    "kycGetHelpSupport": "获取帮助和支持",
    "otpVerified": "验证码已验证",
    "authConnectFailedTitle": "无法连接您的 {{provider}} 账户",
    "authConnectFailedDetail": "请重新开始，从头登录。",
    "kycUnavailableTitle": "验证暂时不可用。",
    "kycUnavailableNetwork": "请稍后重试，或退出后再回来。",
    "kycUnavailableProviderTitle": "我们无法完成验证。",
    "kycUnavailableProvider": "我们这边出现了问题。请联系客服，我们会接手处理。",
    "contactSupport": "联系客服",
    "kycDocumentTitle": "验证您的身份证件",
    "kycDocumentDetail": "我们需要核验你的证件以完成身份验证。身份验证由 {{provider}} 提供支持。",
    "kycDocumentContinue": "使用 {{provider}} 验证身份",
    "applePayUnavailableTitle": "Apple Pay暂时不可用。",
    "kycLimitNotice": "已达到每日限额：立即验证身份，即可提高限额。",
    "contactEmailRejected": "无法验证此电子邮箱地址，请使用其他地址。",
    "contactReverifyPhone": "请重新验证您的手机号码。",
    "coinbaseCardSoftDeclined": "您的银行拒绝了此次付款。请在 Apple Pay 中换一张卡，或联系您的银行。",
    "coinbaseCardHardDeclined": "您的银行拒绝了这张卡。请在 Apple Pay 中使用其他卡。",
    "coinbaseCardRiskDeclined": "此次付款未能通过。请在 Apple Pay 中改用其他卡。",
    "coinbaseInvalidCard": "请检查 Apple Pay 中的卡片和账单地址，然后重试。",
    "coinbaseInsufficientBalance": "该卡余额不足以完成此次充值。",
    "coinbasePrepaidCard": "不接受预付卡。请在 Apple Pay 中使用借记卡。",
    "coinbaseRegionUnsupported": "您所在的地区无法使用银行卡充值。",
    "coinbasePermissionDenied": "您的账户无法使用此付款方式。",
    "coinbaseWeeklyLimit": "此金额将超出您每周的银行卡充值限额。请尝试较小的金额。",
    "coinbaseLifetimeCount": "您已用完无需 Coinbase 账户即可进行的银行卡充值次数。",
    "coinbaseDailyCount": "您已达到今日的银行卡充值上限。请明天再试。",
    "coinbaseBillingZip": "账单邮政编码与您的卡不符。请核对后重试。",
    "coinbaseBillingAddress": "账单地址不完整。请核对后重试。",
    "coinbaseBillingName": "持卡人姓名未被接受。请核对后重试。",
    "coinbaseSessionExpired": "此付款会话已过期。请重新开始充值。",
    "coinbaseNetworkUnsupported": "您所在的地区无法使用该网络。",
    "coinbaseAssetUnsupported": "您所在的地区无法使用该代币。",
    "coinbaseProviderError": "Coinbase 未能完成此操作。请稍后重试。",
    "coinbaseBuyFailed": "购买未能完成。您的卡未被扣款。",
    "coinbaseSendFailed": "充值未能送达。款项将退回您的卡。",
    "coinbaseAvsFailed": "无法验证您的账单地址。请与银行核对后重试。",
    "cancelled": "存入已取消",
    "sessionExpired": "会话已过期。请重新登录以继续存入。",
    "accountIneligibleTitle": "此账户无法使用存入功能",
    "accountIneligibleDetail": "如果您认为这是错误，请联系客服。"
  },
  "fops": {
    "bankTransferSubtitle": "限额 {{limit}} · 1-2 天",
    "bankTransferTime": "1-2 天",
    "instant": "即时",
    "limit": "限额 {{limit}}"
  },
  "networks": {
    "chainFallback": "链 {{chainId}}",
    "minimum": "最低 ${{min}}"
  },
  "qrCode": {
    "title": "二维码"
  },
  "selectChain": {
    "subtitle": "选择存入的网络",
    "title": "存入加密货币"
  },
  "selectMethod": {
    "crypto": "加密货币",
    "depositTo": "存入",
    "errorMessage": "加载数据时出现问题。\n请检查网络连接后重试。",
    "errorTitle": "出现问题",
    "loadingMethods": "正在加载支付方式",
    "noLimit": "无限额",
    "payWith": "支付方式",
    "title": "添加资金"
  },
  "selectReceiveToken": {
    "availableTokens": "可用代币",
    "moreTokens_other": "+{{count}} 个代币",
    "searchTokens": "搜索代币",
    "selectChain": "选择链",
    "selectToken": "选择代币",
    "title": "接收代币与链"
  },
  "transferCrypto": {
    "changeChain": "更改链",
    "depositAddressLabel": "您的入金地址",
    "generating": "生成中…",
    "selectedChain": "已选择的链",
    "share": "分享",
    "shareAddress": "分享地址",
    "showQrCode": "显示二维码",
    "title": "转入加密货币"
  },
  "withdraw": {
    "belowMinimumMessage": "您的余额低于现金提款的最低限额。",
    "belowMinimumTitle": "余额不足",
    "cashMethodsError": "加载现金提取方式失败。你仍可通过加密货币提取。",
    "noCashMethods": "银行和银行卡提现在你所在地区不可用。你仍可通过加密货币提取。",
    "title": "提款",
    "unavailableMessage": "现金提款目前在您所在的地区不可用。",
    "unavailableTitle": "提款不可用"
  },
  "withdrawAddress": {
    "breakdown": "您将收到约 {{amount}}。金额可能因网络状况略有变化。此交易不会以低于 {{minimum}} 的价格成交。交易应在几秒内完成。",
    "breakdownTitle": "交易明细",
    "clear": "清除",
    "detected": "已检测到钱包",
    "notFound": "未找到钱包",
    "paste": "粘贴",
    "requested": "提现已请求",
    "title": "提取 {{amount}}",
    "useConnected": "使用已连接钱包",
    "withdrawNow": "立即提取",
    "withdrawing": "提取中",
    "withdrew": "已提取",
    "youllReceive": "您将收到"
  },
  "withdrawAmount": {
    "amountLabel": "金额",
    "delete": "删除",
    "swapDenomination": "在美元和代币之间切换",
    "useMax": "使用全部"
  },
  "withdrawCrypto": {
    "aboveBalance": "余额不足",
    "addressPlaceholder": "钱包地址",
    "available": "可用 {{amount}} {{symbol}}",
    "belowFee": "金额必须大于 {{amount}} 手续费",
    "belowMinimum": "最低金额为 {{amount}}",
    "ctaInvalidForChain": "该地址在此网络上无效",
    "ctaMaxExceeded": "超出最大金额",
    "ctaRecipientSameAsSource": "请选择其他地址",
    "ctaSelectDestination": "请选择目标",
    "errorGeneric": "提现失败。请重试。",
    "errorInsufficientGas": "燃料不足，无法完成此交易。",
    "errorSwitchChain": "无法切换网络。请确保您的钱包支持该网络。",
    "failedMessage": "{{amount}} 未送达收款方。若资金未退回，请联系客服。",
    "failedTitle": "提现未完成",
    "max": "最大",
    "methodSubtitle": "无限额",
    "methodTitle": "加密货币地址",
    "quoteFailed": "获取兑换报价失败。请重试。",
    "receiveAs": "接收币种",
    "refundedMessage": "{{amount}} 已退回您的钱包。",
    "riskyAddress": "由于限制，此钱包地址无法使用。",
    "selectSource": "选择来源",
    "sendFrom": "提现来源",
    "successPendingMessage": "{{amount}} 正在链上结算。你可以关闭此页面。",
    "successPendingTitle": "提款已发送",
    "title": "提取加密货币",
    "unsupportedRecipient": "不支持的接收地址"
  },
  "withdrawLighter": {
    "delayHours": "{{hours}}小时",
    "delayHoursMinutes": "{{hours}}小时{{minutes}}分钟",
    "delayMinutes": "{{minutes}}分钟",
    "delaySecond": "1秒",
    "delaySeconds": "{{seconds}}秒",
    "fastDisclaimer": "仅限USDC永续 · 多链 · 即时",
    "fastDisclaimerUnified": "仅限USDC · 多链 · 即时",
    "methodFast": "快速",
    "methodSecure": "原生跨链桥",
    "secureDisclaimer": "所有代币 · 仅以太坊链 · {{delay}}",
    "secureFallbackDelay": "60分钟以上"
  },
  "withdrawNado": {
    "errorAmountTooLow": "金额过低，不足以支付 Nado 提现费用。",
    "errorBalanceChanged": "您的可提现余额已变动。请点击「最大」后重试。",
    "errorInvalidNonce": "此提现请求已过期。请重试。",
    "errorNetwork": "目前无法连接 Nado。请重试。",
    "errorNoPriorDeposit": "请先向 Nado 存入资金，然后再提现。",
    "errorRateLimited": "请求过于频繁。请稍等后重试。",
    "errorSignerMismatch": "请切换回拥有此 Nado 账户的钱包以进行提现。",
    "errorUnconfirmed": "我们无法确认您的提现。请先查看您的 Nado 余额，然后再重试。",
    "errorWithdrawRisk": "已达到 Nado 的 24 小时提现限额。请稍后重试。"
  },
  "paymentMethods": {
    "applePay": "Apple Pay",
    "card": "银行卡"
  },
  "lockedTransfer": {
    "amountInfoTitle": "发送金额",
    "amountInfoDescription": "您应发送此金额以存入{{amount}}。超出此金额的资金将不会入账，需要联系支持团队才能找回。",
    "amountLoading": "计算中…",
    "amountUnavailable": "金额暂不可用",
    "title": "存入加密货币",
    "send": "发送",
    "amount": "金额",
    "address": "一次性充值地址",
    "copyAmount": "复制金额",
    "amountCopied": "金额已复制",
    "showFullAddress": "显示完整地址",
    "tokenOnChain": "{{chain}}上的{{token}}"
  },
  "selectAsset": {
    "emptyChains": "暂无支持的网络",
    "combinedTitle": "要发送的代币和网络",
    "title": "选择资产",
    "empty": "暂无支持的资产"
  }
}
